// ===== CSV para planilha (exportações do dashboard e relatórios) =====

/** Marca de ordem de bytes: o Excel só abre UTF-8 (acentos) com ela. */
export const CSV_BOM = "\uFEFF";
export type CsvValue = string | number | null | undefined;

/**
 * Número como a planilha em pt-BR lê (sinal opcional, vírgula decimal, milhar com ponto em grupos de 3, como o
 * `formatBRL` sem o símbolo): nunca é fórmula, então fica intacto.
 */
const NUMERIC = /^-?(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d+)?$/;
/**
 * Começo que a planilha interpreta como fórmula (OWASP "CSV injection"), mesmo depois de espaços (inclusive o
 * ideográfico), com pipe (DDE), % ou os sinais em largura total — as mesmas regras do CSV das exportações (SEG22).
 */
const FORMULA_START = /^[\s\u3000]*[=+\-@|%＝＋－＠]/;

/**
 * Uma célula: quebras de linha e tabulações viram espaço, texto que a planilha leria como fórmula ganha um apóstrofo
 * na frente (vira texto) e o valor vai entre aspas quando tem aspas ou o delimitador. Número fica como está.
 */
export function csvCell(v: CsvValue, delimiter = ";"): string {
  if (v === null || v === undefined) return "";
  let s = String(v).replace(/[\r\n\t]+/g, " ");
  if (!NUMERIC.test(s) && FORMULA_START.test(s)) s = `'${s}`;
  return s.includes('"') || s.includes(delimiter) ? `"${s.replaceAll('"', '""')}"` : s;
}

/** Documento CSV (";" e CRLF por padrão, com BOM) a partir das linhas já formatadas. */
export function toCsv(rows: CsvValue[][], o: { delimiter?: string; bom?: boolean } = {}): string {
  const d = o.delimiter ?? ";";
  const body = rows.map((r) => r.map((c) => csvCell(c, d)).join(d) + "\r\n").join("");
  return (o.bom === false ? "" : CSV_BOM) + body;
}
